module.exports = __webpack_public_path__ + "static/media/question-screenshot.9ed5bf05.png";